<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">{{ $t('panelCliente.datosCuentaTitulo') }}</h6>
              <p class="text-xs opacity-7 mb-0">{{ $t('panelCliente.datosCuentaSubtitulo') }}</p>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.nombre') }}</div>
                <div class="v text-sm">{{ cuenta?.name || "-" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.usuario') }}</div>
                <div class="v text-sm">{{ cuenta?.username || "-" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.email') }}</div>
                <div class="v text-sm">{{ cuenta?.email || "-" }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.telegram') }}</div>
                <div class="v text-sm">{{ cuenta?.telegram_id || $t('panelCliente.noVinculado') }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.emailVerificado') }}</div>
                <div class="v text-sm">{{ cuenta?.email_verified ? $t('panelCliente.si') : $t('panelCliente.no') }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-xl-4">
              <div class="mini-card mini-card-left">
                <div class="k">{{ $t('panelCliente.alta') }}</div>
                <div class="v text-sm">{{ fmtFechaHora(cuenta?.created_at) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelClienteCuenta",
  props: {
    cuenta: { type: Object, default: null },
  },
  methods: {
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      try {
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        const locale = this.$i18n?.locale === 'en' ? 'en-GB' : 'es-ES';
        return d.toLocaleString(locale);
      } catch {
        return fechaStr;
      }
    },
  },
};
</script>

<style scoped>
.mini-card {
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
  border-radius: 12px;
  padding: 12px 14px;
  height: 100%;
  min-height: 92px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 6px;
}
.mini-card-left { align-items: flex-start; text-align: left; }
.mini-card .k {
  font-size: 12px;
  opacity: .7;
  line-height: 1.15;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mini-card .v { font-size: 18px; font-weight: 700; }
</style>
